"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethod = void 0;
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["WIRE"] = "WIRE";
    PaymentMethod["CASH"] = "CASH";
    PaymentMethod["CC"] = "CC";
    PaymentMethod["AMEX"] = "AMEX";
    PaymentMethod["AMX"] = "AMX";
    PaymentMethod["EFT"] = "EFT";
    PaymentMethod["EF"] = "EF";
    PaymentMethod["FIS"] = "FIS";
    PaymentMethod["ACH"] = "ACH";
    PaymentMethod["MO"] = "MO";
    PaymentMethod["ARC460"] = "ARC460";
    PaymentMethod["CHECK"] = "CHECK";
    PaymentMethod["OTHER"] = "OTHER";
})(PaymentMethod = exports.PaymentMethod || (exports.PaymentMethod = {}));
